import { useEffect, useState } from 'react'
import { Logo } from '../lib/ui'
import { client } from '../lib/api'
import { SafetyRules } from './SafetyRules'

const TITLES: Record<string, string> = {
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  community: 'Safety & Rules',
  cookies: 'Cookie Policy',
}

export function LegalPage({ doc }: { doc: string }) {
  if (doc === 'community') {
    return <SafetyRules backHref="#/" />
  }
  return <LegalDocPage doc={doc} />
}

function LegalDocPage({ doc }: { doc: string }) {
  const [content, setContent] = useState<{ status: string; body: string } | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setContent(null)
    client
      .legal(doc)
      .then((r) => setContent({ status: r.status, body: r.body }))
      .catch((e) => setError((e as Error).message))
  }, [doc])

  return (
    <main className="landing-shell">
      <header className="landing-nav">
        <Logo />
      </header>
      <div className="static-page">
        <a className="back-link" href="#/">
          ← Back
        </a>
        <h1>{TITLES[doc] ?? 'Policy'}</h1>
        {error && <p className="page-sub">{error}</p>}
        {!content && !error && (
          <div className="loading-center">
            <div className="spinner" />
          </div>
        )}
        {content && (
          <>
            <p className="page-sub">{content.status}</p>
            <div className="legal-body">{content.body}</div>
          </>
        )}
      </div>
    </main>
  )
}
